import {
  Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewChecked
} from '@angular/core';
import { sweetAlert } from '../../../utils/swal';
import { ActivatedRoute, Router } from '@angular/router';
import { Events } from '../../../utils/event-utils';
import { SocketService } from '../../../service/socket-service/socket-service.service';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'app-driver-alert',
  templateUrl: './driver-alert.component.html',
  styleUrls: ['./driver-alert.component.css']
})
export class DriverAlertComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('messageTone', { static: true }) messageTone: ElementRef;
  @ViewChild('scrollContainer', { static: false }) private scrollContainer: ElementRef;
  searchMessages = '';
  isSound = true;
  driverList = [];
  driverSms = [];
  searchDriver: any;
  newMessage = null;
  user;
  selectedDriver;
  driverId;
  shouldScroll = false;
  isTyping = false;
  skip = 0;
  hasMore = true;
  loadingMore = false;
  endPoint = null;

  constructor(
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private socketService: SocketService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.getUser();
    this.driverId = history.state.id || history.state.driver;
    this.endPoint = this.activatedRoute.snapshot.url[1].path;

    if (this.endPoint === 'chats') this.getDriverList();
    else if (this.endPoint === 'queries') this.getQueriesUserList();

    this.setUpDriverAlertSocketListener();
    this.getRedirectEntity();
  }

  getRedirectEntity() {
    this.sharedDataService
      .getSupportChatRedirectEntity()
      .subscribe(data => {
        if (data && data.id) {
          this.driverId = data.id;
          if (this.endPoint === 'chats') this.getDriverList();
          else if (this.endPoint === 'queries') this.getQueriesUserList();
        }
      });
  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) this.user = user;
      });
  }

  getDriverList() {
    this.driverService.getAlertDrivers()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.driverList = data || [];
        this.driverList.sort((a, b) => (b.unreadMessages || 9999) - (a.unreadMessages || 9999));

        const driverObj = (this.driverId && this.driverList.find(d => d._id === this.driverId)) || this.driverList[0];
        if (driverObj) this.fetchSms(driverObj);
      });
  }

  getQueriesUserList() {
    this.driverService.getQueriesUserList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.driverList = data || [];
        if (this.driverList[0]) this.fetchSms(this.driverList[0]);
      });
  }

fetchSms(userObj) {
  this.selectedDriver = userObj;
  this.driverSms = [];
  this.skip = 0;
  this.hasMore = true;
  this.loadMessages(false);
}

loadMessages(append: boolean) {
  if (!this.selectedDriver || this.loadingMore) return;

  this.loadingMore = true;
  const payload = {
    receiver: this.selectedDriver._id,
    skip: this.skip
  };

  this.driverService.getDriversSms(payload)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      const messages = data || [];

      if (messages.length === 0) this.hasMore = false;

      if (append) {
        this.driverSms = [...messages, ...this.driverSms];
      } else {
        this.driverSms = messages;
        this.shouldScroll = true;
      }

      this.driverSms.forEach(data => {
        if (this.selectedDriver && data.sender._id === this.selectedDriver._id && !data.isRead) {
          this.socketService.emit(Events.ALERT_MARK_AS_READ, data._id);
        }
      });

      this.skip += messages.length;

      this.loadingMore = false;
    }, err => {
      sweetAlert('Error', err, 'error', 'OK');
      this.loadingMore = false;
    });
}

onScroll(event: any) {
  const top = event.target.scrollTop;
  if (top === 0 && this.hasMore && !this.loadingMore) {
    const prevScrollHeight = this.scrollContainer.nativeElement.scrollHeight;

    this.loadMessages(true);

    setTimeout(() => {
      const newScrollHeight = this.scrollContainer.nativeElement.scrollHeight;
      this.scrollContainer.nativeElement.scrollTop =
        newScrollHeight - prevScrollHeight;
    }, 300);
  }
}


  shouldShowDateDivider(index: number): boolean {
    if (index === 0) return true;
    const prev = new Date(this.driverSms[index - 1].created);
    const curr = new Date(this.driverSms[index].created);
    return prev.toDateString() !== curr.toDateString();
  }

  formatDateDivider(date: string) {
    const msgDate = new Date(date);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (msgDate.toDateString() === today.toDateString()) return 'Today';
    if (msgDate.toDateString() === yesterday.toDateString()) return 'Yesterday';
    return msgDate.toLocaleDateString();
  }

    call() {
    const callTo = {
      to: this.selectedDriver._id,
      status: 'join'
    };
    this.socketService.emit(Events.DRIVER_CALL, callTo);
    this.sendMessage('outbound')
  }

  sendMessage(callBound?) {
    if (!this.newMessage || !this.selectedDriver) return;

    const message = {
      title: '',
      message: this.newMessage ? this.newMessage : callBound,
      receiver: this.selectedDriver
    };

    this.socketService.emit(Events.DRIVER_ALERT_CALL, message);
    this.newMessage = null;
  }

  setUpDriverAlertSocketListener() {
    this.socketService.addListener(Events.DRIVER_ALERT_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          data.driverAlert.status = '✓';
          setTimeout(() => (data.driverAlert.status = '✓✓'), 2000);
          this.driverSms.push(data.driverAlert);
          this.shouldScroll = true;
          this.onMessagePlay();
        }
      });

    this.socketService.addListener(Events.RECEIVE_DRIVER_ALERT_MESSAGE_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success && this.selectedDriver && data.driverAlert.sender._id === this.selectedDriver._id) {
          data.driverAlert.status = 'read';
          this.driverSms.push({...data.driverAlert, isRead: true});
          this.socketService.emit(Events.ALERT_MARK_AS_READ, data.driverAlert._id);
          this.shouldScroll = true;
        }
      });
  }

  scrollToBottom(): void {
    try {
      this.scrollContainer.nativeElement.scrollTo({
        top: this.scrollContainer.nativeElement.scrollHeight,
        behavior: 'smooth'
      });
    } catch {}
  }

  onMessagePlay() {
    if (this.isSound) this.messageTone.nativeElement.play();
  }

  ngAfterViewChecked() {
    if (this.shouldScroll) {
      this.scrollToBottom();
      this.shouldScroll = false;
    }
  }

  getImage(userObj) {
    if (this.endPoint === 'queries') {
      return userObj.driver.profileImageURL || '#';
    }
    return userObj.profileImageURL || '/assets/images/placeholders/driver-placeholder.png';
  }

  getDisplayName(userObj) {
    if (this.endPoint === 'queries') {
      return userObj.driver.displayName || 'N/A';
    }
    return userObj.displayName || 'N/A';
  }

  autoResize(event: Event) {
  const textarea = event.target as HTMLTextAreaElement;
  textarea.style.height = 'auto';
  textarea.style.height = textarea.scrollHeight + 'px';
}


  ngOnDestroy(): void {}
}
